/**
 * Set cookie.
 * @param {String} name
 * @param {String} value
 * @param {Number} days
 * @returns Void
 */
const setCookie = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  // TYNA 2026-07-27: + SameSite=Lax e Secure (a loja é HTTPS).
  document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax; Secure';
};

/**
 * Get cookie data.
 * @param {String} name
 * @returns {String|Null}|
 */
const getCookie = name => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Erase cookie value
 * @param {String} name
 */
const eraseCookie = name => {
  document.cookie = name + '=; Max-Age=-99999999; path=/; SameSite=Lax; Secure';
};

/**
 * TYNA 2026-07-28 — LGPD: verifica se o titular consentiu com processamento
 * de analytics via Customer Privacy API da Shopify (populada quando o banner
 * de cookies nativo está ativo em Configurações → Privacidade do cliente).
 * Sem API disponível ou sem resposta, o padrão é NÃO tratar (false).
 * Uso: armazenamentos não essenciais (ex.: histórico de produtos vistos).
 * Cookies estritamente funcionais (age-verified, newsletter-closed) não
 * passam por aqui — são preferências do próprio usuário, sem dado pessoal.
 */
const analyticsConsentGranted = () => {
  try {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (customerPrivacy && typeof customerPrivacy.analyticsProcessingAllowed === 'function') {
      return customerPrivacy.analyticsProcessingAllowed() === true;
    }
  } catch (error) {
    /* API indisponível — trata como sem consentimento */
  }
  return false;
};
